export enum EntraRoles {
    USER = 'User',
    PRIVILEGED_QS = 'PrivilegedQS',
    QUARTERLY_EXPORT = 'QuarterlyExport'
}
